import React from "react";
import { TApplicantReportingPeriodPresentationModel } from "../../../../presenter/applicants/model/ApplicantReportingPeriodPresentationModel";
import { TReportingPeriodFormTypePresentationModel } from "../../../../model/form/mappers/ReportingPeriodFormTypeListMapper";
import { TBoFormVersionPresentationModel } from "../../../../presenter/applicants/model/BoFormVersionPresentationModel";
import ReportingPeriodFormVersionGrid from "../../../components/applicants/details/ReportingPeriodFormVersionGrid";
import { IRegisteredApplicant } from "../../../../model/applicant/RegisteredApplicant";
import { IConfiguration } from "../../../../model/config/Configuration";

export interface Props {
  reportingPeriods: TApplicantReportingPeriodPresentationModel[];
  translate: any;
  formTypes: TReportingPeriodFormTypePresentationModel[];
  formVersions: TBoFormVersionPresentationModel[];
  onExpandReportingPeriod: any;
  onExpandFormType: any;
  formTypesLoader?: boolean;
  formVersionsLoader?: boolean;
  onChangeModalVisible: any;
  applicant: IRegisteredApplicant;
  addNewDraftFormVersion?: any;
  updateAdditionalEvalutionResult?: (
    reportingPeriodApplicantId: number,
    result: string
  ) => void;
  getAdditionalEvaluationResult?: (
    reportingPeriodApplicantId: number
  ) => Promise<string | undefined>;
  configuration: IConfiguration;
}

export interface State {}

export default class ApplicantFormsGrid extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  render() {
    const {
      reportingPeriods,
      translate,
      formTypes,
      onExpandReportingPeriod,
      onExpandFormType,
      formVersions,
      formTypesLoader,
      formVersionsLoader,
      onChangeModalVisible,
      applicant,
      addNewDraftFormVersion,
      updateAdditionalEvalutionResult,
      getAdditionalEvaluationResult,
      configuration
    } = this.props;

    return (
      <div>
        <ReportingPeriodFormVersionGrid
          title={translate("grids.applicant-forms")}
          reportingPeriods={reportingPeriods}
          translate={translate}
          formTypes={formTypes}
          onExpandReportingPeriod={onExpandReportingPeriod}
          formVersions={formVersions}
          formTypesLoader={formTypesLoader}
          formVersionsLoader={formVersionsLoader}
          onExpandFormType={onExpandFormType}
          onChangeModalVisible={onChangeModalVisible}
          applicant={applicant}
          addNewDraftFormVersion={addNewDraftFormVersion}
          isApplicantForms={true}
          updateAdditionalEvalutionResult={updateAdditionalEvalutionResult}
          getAdditionalEvaluationResult={getAdditionalEvaluationResult}
          configuration={configuration}
        />
      </div>
    );
  }
}
